(function() { window.GUID_bde22fcc_0739_4fc0_be2d_be59ad1e4f4a = { getGuid: function() { return "bde22fcc-0739-4fc0-be2d-be59ad1e4f4a"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ScriptErrorPopup extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            constructor(controlId, ...params) {
                super(controlId, ...params);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnControlRendered() {
                try {
                    this.$Control.trigger(`ready`);
                }
                catch (error) {
                    console.error("Error in OnControlRendered", error);
                }
            }
            OnBindEvents() {
                try {
                    CS.Helper.log("ScriptErrorPopup", "Binding events...");
                    const gridid = `${this.ControlId}-grid`;
                    this.$Control.append(`<div id=${gridid}></div>`);
                    this.LogErrorInPopup(gridid);
                    CS.Helper.log("ScriptErrorPopup", `Successfully bound events`);
                }
                catch (error) {
                    console.error("Error while binding to match card events", error);
                }
            }
            LogErrorInPopup(gridid) {
                try {
                    requestAnimationFrame(() => {
                        const $tbody = $(`#${gridid}`).closest(".popup").find("tbody");
                        if ($tbody.length === 0) {
                            console.error(`Container with id ${gridid} not found`);
                            return;
                        }
                        Controls.ScriptErrorStatic.Instance.errors.forEach((error) => {
                            $tbody.append(`<tr><td><div>${error}</div></td></tr>`);
                        });
                    });
                }
                catch (error) {
                    console.error("Error while binding to ScriptErrorPopup", error);
                }
            }
            OnDispose() { }
        }
        Controls.ScriptErrorPopup = ScriptErrorPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ScriptErrorPopup.js.map
